var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStop({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19,10.7h-7.9c-0.2,0-0.3,0.1-0.3,0.3v8c0,0.2,0.2,0.3,0.3,0.3H19c0.2,0,0.3-0.2,0.3-0.3v-8 C19.3,10.8,19.2,10.7,19,10.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15,0C6.7,0,0,6.7,0,15s6.7,15,15,15c8.3,0,15-6.7,15-15S23.3,0,15,0z M15,27.5C8.1,27.5,2.5,21.9,2.5,15 C2.5,8.1,8.1,2.5,15,2.5c6.9,0,12.5,5.6,12.5,12.5C27.5,21.9,21.9,27.5,15,27.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStop);
export default __webpack_public_path__ + "static/media/stop.3db9060fd9eec814fbdd55680f516ccb.svg";
export { ForwardRef as ReactComponent };